import type { FC } from "react";

import {
  type THeaderMenuProps,
} from "@/ui/components/navigation/Header/Header.config";
import {
  HeaderDesktopMenu,
} from "@/ui/components/navigation/Header/HeaderDesktopMenu";
import {
  HeaderMobileMenu,
} from "@/ui/components/navigation/Header/HeaderMobileMenu";
import { useHeaderMenu } from "@/ui/components/navigation/Header/useHeaderMenu";

export const HeaderMenu: FC<THeaderMenuProps> = ({ items }) => {
  const { isHeaderMenuDesktop } = useHeaderMenu();

  if (!items?.length) { return null; }

  return (
    <div data-component="HeaderMenu">
      { isHeaderMenuDesktop ? (
        <HeaderDesktopMenu items={items} />
      ) : (
        <HeaderMobileMenu items={items} />
      ) }
    </div>
  );
};

HeaderMenu.displayName = "HeaderMenu";
